export default __webpack_public_path__ + "static/media/arrowLongRight.c9b03446.svg";